import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../config/URL";
import toast from "react-hot-toast";
import ImageURL from "../../../config/ImageURL";

function LeadMagnet() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/lead_magnet`);
      setData(response.data.data);
    } catch (error) {
      toast.error("Error Fetching Data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const handleToggleStatus = async () => {
    setLoadIndicator(true);
    try {
      const res = await api.post(`admin/lead_magnet/status`);
      const { success, message } = res.data || {};
      if (success) {
        toast.success(message);
        setData((prev) => ({
          ...prev,
          is_active:
            prev.is_active === 1 || prev.is_active === "1" ? 0 : 1,
        }));
      } else {
        toast.error(message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
    setLoadIndicator(false);
  };

  return (
    <section className="px-4">
      <>
        <div className="card shadow border-0 mb-3">
          <div className="row p-3">
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                <h3 className="ls-tight">Lead Magnet</h3>
              </div>
              <div className="d-flex">
                <div>
                  <button
                    type="button"
                    onClick={handleToggleStatus}
                    className={`btn btn-sm me-2 ${data?.is_active === 1 || data?.is_active === "1" ? "btn-danger" : "btn-success"}`}
                    disabled={loadIndicator}
                  >
                    {loadIndicator && (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        aria-hidden="true"
                      ></span>
                    )}
                    {data?.is_active === 1 || data?.is_active === "1" ? "Deactivate" : "Activate"}
                  </button>
                </div>
                <div>
                  <Link to={`/leadmagnet/edit`}>
                    <button type="button" className="btn btn-light btn-sm">
                      Edit
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="container card shadow border-0"
          style={{ minHeight: "80vh" }}
        >
          {loading ? (
            <div className="loader-container">
              <div className="loader">
                <svg viewBox="0 0 80 80">
                  <circle cx="40" cy="40" r="32"></circle>
                </svg>
              </div>
            </div>
          ) : (
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Title</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.title || "-"}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Target Type</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.target_type ? data.target_type.charAt(0).toUpperCase() + data.target_type.slice(1) : "-"}
                    </p>
                  </div>
                </div>
              </div>
              {data?.target_type && data?.target_type !== "default" && (
                <>
                  <div className="col-md-6 col-12">
                    <div className="row mb-3">
                      <div className="col-6 d-flex justify-content-start align-items-center">
                        <p className="text-sm">Web URL</p>
                      </div>
                      <div className="col-6">
                        <p className="text-muted text-sm">
                          : {data?.web_url || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="row mb-3">
                      <div className="col-6 d-flex justify-content-start align-items-center">
                        <p className="text-sm">App URL</p>
                      </div>
                      <div className="col-6">
                        <p className="text-muted text-sm">
                          : {data?.app_url || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
               <div className="col-12">
                <div className="row mb-3">
                  <div className="col-3 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Description</p>
                  </div>
                  <div className="col-9">
                    <p className="text-muted text-sm">
                      : {data?.description || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Image</p>
                  </div>
                  <div className="col-6">
                    <img
                      src={`${ImageURL}${data?.image}`}
                      alt="lead_magnet"
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    </section>
  );
}

export default LeadMagnet;